import React, { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { ViewLoader } from '../views/FlowDesigner/Components/ViewLoader';
import { useCurrentUserPermissions } from './CurrentUserPermissionsContext';
import useHasPermission from '../common/hooks/useHasPermission';

interface RequirePermissionProps extends PropsWithChildren {
	permissionId?: string;
	permissionIds?: string[];
	matchAny?: boolean;
}

export default function RequirePermission({ permissionId, permissionIds, matchAny = false, children }: RequirePermissionProps) {
	const { isLoading, hasPermission } = useCurrentUserPermissions();
	const requiredPermissionIds = permissionIds ?? (permissionId ? [permissionId] : []);
	const hasAllPermissions = useHasPermission(requiredPermissionIds);
	const hasRequiredPermissions = matchAny ? requiredPermissionIds.some(hasPermission) : hasAllPermissions;

	if (isLoading) {
		return <ViewLoader />;
	}

	if (!hasRequiredPermissions) {
		return <Navigate to="/?error=insufficient_permissions" replace />;
	}

	return <>{children}</>;
}
